import { collectorCheckpointConstants } from './collectorCheckpointConstants';
import {userConstants} from "../../../auth/_redux/authConstants";

const makeInitialState = () => ({
  requestActive: false,
  requestSaveActive: false,
  shouldReload: true,
  items: [],
  logItems: [],
  rowsPerPage: 10,
  page: 1,
  sortBy: "timestamp",
  sortDirection: "desc",
  startDate: null,
  endDate: null,
  total: 0,
  logTotal: 0,
  error: '',
  query: "",
  inProgress: true,
});

export function reports_collector_checkpoints(state = makeInitialState(), action) {
  switch (action.type) {
    case userConstants.LOGOUT:
      return makeInitialState();
    case collectorCheckpointConstants.COLLECTOR_CHECKPOINTS_LIST_REQUEST:
    case collectorCheckpointConstants.COLLECTOR_CHECKPOINTS_LOAD_REQUEST:
      return {
        ...state,
        requestActive: true,
        shouldReload: false,
        error: '',
        total: 0,
        logTotal: 0,
        inProgress: true,
      };
    case collectorCheckpointConstants.COLLECTOR_CHECKPOINTS_LIST_SUCCESS: {
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        items: action.collectorCheckpoints.rows ? action.collectorCheckpoints.rows : [],
        total: action.collectorCheckpoints.total ? action.collectorCheckpoints.total : 0,
        inProgress: false,
      };
    }
    case collectorCheckpointConstants.COLLECTOR_CHECKPOINTS_LOAD_SUCCESS: {
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        logItems: action.collectorCheckpoint.rows ? action.collectorCheckpoint.rows : [],
        logTotal: action.collectorCheckpoint.total ? action.collectorCheckpoint.total : 0,
        inProgress: false,
      };
    }
    case collectorCheckpointConstants.COLLECTOR_CHECKPOINTS_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        inProgress: false,
      };
    case collectorCheckpointConstants.COLLECTOR_CHECKPOINTS_LIST_CHANGED:
      return {
        ...state,
        shouldReload: true,
      };
    case collectorCheckpointConstants.COLLECTOR_CHECKPOINTS_LIST_PAGINATION: {
      let shouldReload = state.items.length === 0 ? true : false;

      if (state.rowsPerPage !== action.pagination.rowsPerPage
        || state.page !== action.pagination.page
        || state.sortBy !== action.pagination.sortBy
        || state.sortDirection !== action.pagination.sortDirection
        || state.query !== action.pagination.query
        || state.startDate !== action.pagination.startDate
        || state.endDate !== action.pagination.endDate
        || state.exactValues !== action.pagination.exactValues
        || state.exactFields !== action.pagination.exactFields
        || state.collectorCheckpointId !== action.pagination.collectorCheckpointId
        || state.shouldReload) {
        shouldReload = true;
      }

      return {
        ...state,
        rowsPerPage: action.pagination.rowsPerPage,
        page: action.pagination.page,
        sortBy: action.pagination.sortBy,
        sortDirection: action.pagination.sortDirection,
        query: action.pagination.query,
        startDate: action.pagination.startDate,
        endDate: action.pagination.endDate,
        exactValues: action.pagination.exactValues,
        exactFields: action.pagination.exactFields,
        collectorCheckpointId: action.pagination.collectorCheckpointId,
        shouldReload
      };
    }
    default:
      return state
  }
}
